import { Component, inject, input, output } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ModalService } from '../../services/modal.service';
import { AuthService } from '../../services/auth.service.service';

@Component({
  selector: 'debtor-panel-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [
    MatDividerModule,
    TranslateModule,
    CommonModule,
  ],
})
export class FooterComponent {
  protected modalService = inject(ModalService);
  protected authService = inject(AuthService);
  public transparent = input<boolean>(false);
  public navigateToOrderContact = output();

  protected openModal(event: Event): void {
    event.preventDefault();
    this.modalService.openContactModal();
  }

  protected navigateToOrderContactClick(event: Event): void {
    event.preventDefault();
    this.navigateToOrderContact.emit();
  }
}
